import React from 'react'

/**
 * Renders a string with /n separators (space + forward slash + n + space) converted to line breaks
 * Only splits when /n has a space before AND after it to avoid splitting words like "this/nis"
 *
 * @param text - The string potentially containing " /n " separators
 * @returns React elements with proper line breaks
 *
 * @example
 * const headline = "Save your passwords /n and access them anywhere"
 * return <h1>{renderWithBreaks(headline)}</h1>
 */
export function renderWithBreaks(text: string): React.ReactNode {
  if (!text) return text

  // Split on literal /n with required spaces before and after
  const parts = text.split(/ \/n /)

  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {part}
      {index < parts.length - 1 && <br />}
    </React.Fragment>
  ))
}
